<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <b-form @submit="onSubmit1" @reset="onReset1" v-if="show">
          <b-form-group
            label="1. Script De bienvenida - Saludo"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_1"
                  :aria-describedby="ariaDescribedby"
                  name="question_1"
                  value="0.05"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.05</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_1"
                  :aria-describedby="ariaDescribedby"
                  name="question_1"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_1"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="2. Script  - detección de necesidades"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_2"
                  :aria-describedby="ariaDescribedby"
                  name="question_2"
                  value="0.03"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.03</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_2"
                  :aria-describedby="ariaDescribedby"
                  name="question_2"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>
            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_2"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="3. Sondeo"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_3"
                  :aria-describedby="ariaDescribedby"
                  name="question_3"
                  value="0.07"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.07</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_3"
                  :aria-describedby="ariaDescribedby"
                  name="question_3"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>
            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_3"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="4. Reformulacion"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_4"
                  :aria-describedby="ariaDescribedby"
                  name="question_4"
                  value="0.09"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.09</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_4"
                  :aria-describedby="ariaDescribedby"
                  name="question_4"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_4"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="5. Parafraseo"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_5"
                  :aria-describedby="ariaDescribedby"
                  name="question_5"
                  value="0.05"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.05</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_5"
                  :aria-describedby="ariaDescribedby"
                  name="question_5"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>


            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_5"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="6. Validación de datos"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_6"
                  :aria-describedby="ariaDescribedby"
                  name="question_6"
                  value="0.08"
                  required
                  >BAJO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.08</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_6"
                  :aria-describedby="ariaDescribedby"
                  name="question_6"
                  value="0"
                  required
                  >REGULAR</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_6"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="7. Habilidades Blandas - Voz"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_7"
                  :aria-describedby="ariaDescribedby"
                  name="question_7"
                  value="1"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.05</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_7"
                  :aria-describedby="ariaDescribedby"
                  name="question_7"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>
            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_7"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="8. Proceso de llamada (Procedimientos/Conocimientos) - Habilidades Duras"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_8"
                  :aria-describedby="ariaDescribedby"
                  name="question_8"
                  value="0.1"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_8"
                  :aria-describedby="ariaDescribedby"
                  name="question_8"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_8"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="9. Uso de Lenguaje"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_9"
                  :aria-describedby="ariaDescribedby"
                  name="question_9"
                  value="0.05"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.05</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_9"
                  :aria-describedby="ariaDescribedby"
                  name="question_9"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_9"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="10. Habilidades blandas"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_10"
                  :aria-describedby="ariaDescribedby"
                  name="question_10"
                  value="0.08"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.08</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_10"
                  :aria-describedby="ariaDescribedby"
                  name="question_10"
                  value="3"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_10"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="11. Personalización de Llamada"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_11"
                  :aria-describedby="ariaDescribedby"
                  name="question_11"
                  value="0.03"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.03</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_11"
                  :aria-describedby="ariaDescribedby"
                  name="question_11"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_11"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="12. Dirección Llamada"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_12"
                  :aria-describedby="ariaDescribedby"
                  name="question_12"
                  value="0.08"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.08</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_12"
                  :aria-describedby="ariaDescribedby"
                  name="question_12"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_12"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="13. Gestión de esperas"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_13"
                  :aria-describedby="ariaDescribedby"
                  name="question_13"
                  value="0.07"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.07</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_13"
                  :aria-describedby="ariaDescribedby"
                  name="question_13"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_13"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="14. Gestión silencios"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_14"
                  :aria-describedby="ariaDescribedby"
                  name="question_14"
                  value="0.05"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.05</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_14"
                  :aria-describedby="ariaDescribedby"
                  name="question_14"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_14"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="15. Cierre de Llamada -  Entrega numero de Ticket"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_15"
                  :aria-describedby="ariaDescribedby"
                  name="question_15"
                  value="0.07"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.07</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_15"
                  :aria-describedby="ariaDescribedby"
                  name="question_15"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_15"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="16. Script D. -  Despedida"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_16"
                  :aria-describedby="ariaDescribedby"
                  name="question_16"
                  value="0.05"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0.05</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_16"
                  :aria-describedby="ariaDescribedby"
                  name="question_16"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_16"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="17. Corta la llamada"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_17"
                  :aria-describedby="ariaDescribedby"
                  name="question_17"
                  value="-1"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: -1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_17"
                  :aria-describedby="ariaDescribedby"
                  name="question_17"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_17"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="18. No atiende llamada"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_18"
                  :aria-describedby="ariaDescribedby"
                  name="question_18"
                  value="-1"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: -1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_18"
                  :aria-describedby="ariaDescribedby"
                  name="question_18"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_18"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="19. Transmite Imagen Negativa del Servicio"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_19"
                  :aria-describedby="ariaDescribedby"
                  name="question_19"
                  value="-1"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: -1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_19"
                  :aria-describedby="ariaDescribedby"
                  name="question_19"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_19"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="20. Falta de Respeto al Cliente"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_20"
                  :aria-describedby="ariaDescribedby"
                  name="question_20"
                  value="-1"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: -1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_20"
                  :aria-describedby="ariaDescribedby"
                  name="question_20"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_20"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="21. Mal uso herramienta de trabajo"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_21"
                  :aria-describedby="ariaDescribedby"
                  name="question_21"
                  value="-1"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: -1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_21"
                  :aria-describedby="ariaDescribedby"
                  name="question_21"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_21"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="22. No entrega Solución alternativa"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_22"
                  :aria-describedby="ariaDescribedby"
                  name="question_22"
                  value="-1"
                  required
                  >SI</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: -1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_22"
                  :aria-describedby="ariaDescribedby"
                  name="question_22"
                  value="0"
                  required
                  >NO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_22"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-row class="text-center" align-v="center">
            <b-col>
              <b-button type="submit" class="Rectangle-Copy" variant="primary"
                >Guardar</b-button
              >
              <b-button type="reset" class="Rectangle-Copy-19" variant="danger"
                >Limpiar</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    evaluador: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      show: true,
      formSave: "Calidad ST",
      form: {
        selected_1: null,
        selected_2: null,
        selected_3: null,
        selected_4: null,
        selected_5: null,
        selected_6: null,
        selected_7: null,
        selected_8: null,
        selected_9: null,
        selected_10: null,
        selected_11: null,
        selected_12: null,
        selected_13: null,
        selected_14: null,
        selected_15: null,
        selected_16: null,
        selected_17: null,
        selected_18: null,
        selected_19: null,
        selected_20: null,
        selected_21: null,
        selected_22: null,
        text_1: null,
        text_2: null,
        text_3: null,
        text_4: null,
        text_5: null,
        text_6: null,
        text_7: null,
        text_8: null,
        text_9: null,
        text_10: null,
        text_11: null,
        text_12: null,
        text_13: null,
        text_14: null,
        text_15: null,
        text_16: null,
        text_17: null,
        text_18: null,
        text_19: null,
        text_20: null,
        text_21: null,
        text_22: null,
      },
    };
  },
  methods: {
    onSubmit1(event) {
      event.preventDefault();
      console.log(this.formSave);
      console.log(this.evaluador);
      var evaluacion = {
        interaction_id: this.$route.params.recording_id,
        form: this.formSave,
        evaluator: this.evaluador,
        evaluations: this.form,
        questions: [
          {
            value: 1,
            text: "Script De bienvenida - Saludo",
          },
          {
            value: 2,
            text: "Script  - detección de necesidades",
          },
          {
            value: 3,
            text: "Sondeo",
          },
          {
            value: 4,
            text: "Reformulacion",
          },
          {
            value: 5,
            text: "Parafraseo",
          },
          {
            value: 6,
            text: "Validación de datos",
          },
          {
            value: 7,
            text: "Habilidades Blandas - Voz",
          },
          {
            value: 8,
            text: "Proceso de llamada (Procedimientos/Conocimientos) - Habilidades Duras",
          },
          {
            value: 9,
            text: "Uso de Lenguaje",
          },
          {
            value: 10,
            text: "Habilidades blandas",
          },
          {
            value: 11,
            text: "Personalización de Llamada",
          },
          {
            value: 12,
            text: "Dirección Llamada",
          },
          {
            value: 13,
            text: "Gestión de esperas",
          },
          {
            value: 14,
            text: "Gestión silencios",
          },
          {
            value: 15,
            text: "Cierre de Llamada -  Entrega numero de Ticket",
          },
          {
            value: 16,
            text: "Script D. -  Despedida",
          },
          {
            value: 17,
            text: "Corta la llamada",
          },
          {
            value: 18,
            text: "No atiende llamada",
          },
          {
            value: 19,
            text: "Transmite Imagen Negativa del Servicio",
          },
          {
            value: 20,
            text: "Falta de Respeto al Cliente",
          },
          {
            value: 21,
            text: "Mal uso herramienta de trabajo",
          },
          {
            value: 22,
            text: "No entrega Solución alternativa",
          },
        ],
      };
      console.log(evaluacion);
      this.axios
        .post("/api/createevaluation", evaluacion)
        .then((result) => {
          console.log(result);

          const itemFlush = {
            title: "Success",
            message: "Evaluacion Creada",
            time: 3000,
          };
          this.sendFlushData(itemFlush);
          this.form.selected_1 = null;
          this.form.selected_2 = null;
          this.form.selected_3 = null;
          this.form.selected_4 = null;
          this.form.selected_5 = null;
          this.form.selected_6 = null;
          this.form.selected_7 = null;
          this.form.selected_8 = null;
          this.form.selected_9 = null;
          this.form.selected_10 = null;
          this.form.selected_11 = null;
          this.form.selected_12 = null;
          this.form.selected_13 = null;
          this.form.selected_14 = null;
          this.form.selected_15 = null;
          this.form.selected_16 = null;
          this.form.selected_17 = null;
          this.form.selected_18 = null;
          this.form.selected_19 = null;
          this.form.selected_20 = null;
          this.form.selected_21 = null;
          this.form.selected_22 = null;

          this.form.text_1 = null;
          this.form.text_2 = null;
          this.form.text_3 = null;
          this.form.text_4 = null;
          this.form.text_5 = null;
          this.form.text_6 = null;
          this.form.text_7 = null;
          this.form.text_8 = null;
          this.form.text_9 = null;
          this.form.text_10 = null;
          this.form.text_11 = null;
          this.form.text_12 = null;
          this.form.text_13 = null;
          this.form.text_14 = null;
          this.form.text_15 = null;
          this.form.text_16 = null;
          this.form.text_17 = null;
          this.form.text_18 = null;
          this.form.text_19 = null;
          this.form.text_20 = null;
          this.form.text_21 = null;
          this.form.text_22 = null;

          this.show = false;
          this.$nextTick(() => {
            this.show = true;
          });
        })
        .catch((error) => {
          console.log(error.response.status);
          const itemFlush = {
            title: "Error",
            message: "Intente Nuevamente",
            time: 3000,
          };
          this.sendFlushData(itemFlush);
          if (error.response.status === 403) {
            this.$store.dispatch("auth/logout");
            this.$router.push("/login");
          }
        });
    },
    onReset1(event) {
      event.preventDefault();
      // Reset our form values
      this.form.selected_1 = null;
      this.form.selected_2 = null;
      this.form.selected_3 = null;
      this.form.selected_4 = null;
      this.form.selected_5 = null;
      this.form.selected_6 = null;
      this.form.selected_7 = null;
      this.form.selected_8 = null;
      this.form.selected_9 = null;
      this.form.selected_10 = null;
      this.form.selected_11 = null;
      this.form.selected_12 = null;
      this.form.selected_13 = null;
      this.form.selected_14 = null;
      this.form.selected_15 = null;
      this.form.selected_16 = null;
      this.form.selected_17 = null;
      this.form.selected_18 = null;
      this.form.selected_19 = null;
      this.form.selected_20 = null;
      this.form.selected_21 = null;
      this.form.selected_22 = null;

      this.form.text_1 = null;
      this.form.text_2 = null;
      this.form.text_3 = null;
      this.form.text_4 = null;
      this.form.text_5 = null;
      this.form.text_6 = null;
      this.form.text_7 = null;
      this.form.text_8 = null;
      this.form.text_9 = null;
      this.form.text_10 = null;
      this.form.text_11 = null;
      this.form.text_12 = null;
      this.form.text_13 = null;
      this.form.text_14 = null;
      this.form.text_15 = null;
      this.form.text_16 = null;
      this.form.text_17 = null;
      this.form.text_18 = null;
      this.form.text_19 = null;
      this.form.text_20 = null;
      this.form.text_21 = null;
      this.form.text_22 = null;


      const itemFlush = {
        title: "Info",
        message: "Formulario limpiado correctamente",
        time: 3000,
      };
      this.sendFlushData(itemFlush);
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    sendFlushData(item) {
      this.$emit("getFlushData", item);
    },
  },
};
</script>

<style>
</style>